import React, { FC, useEffect, useState } from 'react'

interface ConfirmationModalState {
  display: boolean,
  type: string,
  name: string,
  callback: VoidFunction
}

interface Props {
  confirmationModalState: ConfirmationModalState
  closeCallback: VoidFunction
}

const ConfirmationModal: FC<Props> = (props) => {
  const {
    confirmationModalState,
    closeCallback,
  } = props

  const [scrollY, setScrollY] = useState<number>(0)

  const [title, setTitle] = useState<string>("")
  const [buttonText, setButtonText] = useState<string>("")

  useEffect(() => {
    const html = document.querySelector('html')
    if (!html) return
    if (confirmationModalState.display) {
      const scroll = window.scrollY
      html.classList.add('modal_open')
      html.style.top = `-${scroll}px`
      setScrollY(scroll)
    } else {
      html.classList.remove('modal_open')
      window.scrollTo(0, scrollY)
      setScrollY(0)
    }
  }, [confirmationModalState.display])

  useEffect(() => {
    if (confirmationModalState.type === "delete") {
      setTitle("削除")
      setButtonText("削除")
    } else if (confirmationModalState.type === "request") {
      setTitle("アプリ申請")
      setButtonText("申請")
    } else if (confirmationModalState.type === "copy") {
      setTitle("プロジェクトコピー")
      setButtonText("コピー")
    } else if (confirmationModalState.type === "power_delete") {
      setTitle("権限の削除")
      setButtonText("削除")
    } else if (confirmationModalState.type === "exclude_delete") {
      setTitle("作業データ生成除外の解除")
      setButtonText("解除")
    } else if (confirmationModalState.type === "category_delete") {
      setTitle("プロジェクトカテゴリーの削除")
      setButtonText("削除")
    }
  }, [confirmationModalState])

  return (
    <>
      {
        confirmationModalState.display && (
          <div className="modal_wrap">
            <div className={`confirmation_modal ${confirmationModalState.display || 'none'}`} style={{ width: "500px" }}>
              <div className="confirmation_modal_header">
                <div className="title">
                  {title}
                </div>
                <button type="button" className="close_modal" onClick={closeCallback}>
                  &times;
                </button>
              </div>
              <div className="confirmation_modal_body">
                {
                  confirmationModalState.type === "delete" && (
                    <>
                      <p>
                        <span id="delete-member-name">{`「${confirmationModalState.name}」`}</span>
                        を削除します。削除すると復元することはできません。
                      </p>
                      <p>
                        本当に削除しますか？
                      </p>
                    </>
                  )
                }
                {
                  confirmationModalState.type === "request" && (
                    <>
                      <p>
                        <span>{confirmationModalState.name}</span>
                      </p>
                      <p>
                        アプリケーションを認識できるように申請をおこないます。
                      </p>
                    </>
                  )
                }
                {
                  confirmationModalState.type === "copy" && (
                    <>
                      <p>
                        {confirmationModalState.name}
                        のコピーをおこないます。
                      </p>
                      <p>
                        ※所属チームはコピーされません
                      </p>
                    </>
                  )
                }
                {
                  confirmationModalState.type === "power_delete" && (
                    <>
                      <p>
                        {confirmationModalState.name}
                        さんの権限を削除します。よろしいですか？
                      </p>
                    </>
                  )
                }
                {
                  confirmationModalState.type === "exclude_delete" && (
                    <>
                      <p>
                        {confirmationModalState.name}
                        さんの作業データ生成除外を解除します。よろしいですか？
                      </p>
                    </>
                  )
                }
                {
                  confirmationModalState.type === "category_delete" && (
                    <>
                      <p>
                        {confirmationModalState.name}
                        を削除します。
                      </p>
                      <p>
                        また、
                        {confirmationModalState.name}
                        を親カテゴリーとするプロジェクトカテゴリーも削除されます。
                      </p>
                      <p>
                        削除してもよろしいですか？
                      </p>
                    </>
                  )
                }
              </div>
              <div className="confirmation_modal_footer">
                <button type="button" className="button cancel" onClick={closeCallback}>
                  キャンセル
                </button>
                <button
                  type="button"
                  className={`button ${confirmationModalState.type}`}
                  onClick={() => {
                    confirmationModalState.callback()
                    closeCallback()
                  }}
                >
                  {buttonText}
                </button>
              </div>
            </div>
            <div className="close_screen gray" role="presentation" onClick={closeCallback} />
          </div>
        )
      }
    </>
  )
}

export default ConfirmationModal
